export default class RedimensionaImagem {

    carregar(img, src) {
        return new Promise((resolve, reject) => {
            img.src = src;
            img.completed ? resolve(img) : img.addEventListener('load', function () {
                resolve(img)
            });
            img.addEventListener('error', reject);
        });
    }

    async redimensionar(src, options) {
        const image = await this.carregar(document.createElement('img'), src);
        let canvas = document.createElement('canvas');
        if (options.width && !options.height) {
            options.height = image.height * (options.width / image.width);
        } else if (!options.width && options.height) {
            options.width = image.width * (options.height / image.height);
        }
        Object.assign(canvas, options);
        canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
        return await new Promise(function (resolve) {           
            const mimeType = (options.type === 'image/jpg') ? 'image/jpeg' : (options.type || 'image/jpeg');
            canvas.toBlob(resolve, mimeType, 0.9);
        });
    }

}